import { useQuery, UseQueryResult } from 'react-query';
import { KiloClassAthleteRetrieve } from 'types';
import { client } from 'utils/api-client';

// Keyed under ['classes', id] so the reservation mutations' invalidations still reach it.
function useClassAthleteRetrieve(
  kiloClassId: string | undefined,
): UseQueryResult<{ data: KiloClassAthleteRetrieve }> {
  return useQuery(
    ['classes', kiloClassId, 'athlete-retrieve'],
    () => client.get(`kilo-classes/${kiloClassId}/athlete-retrieve/`),
    { enabled: !!kiloClassId },
  );
}

export default useClassAthleteRetrieve;
